export const createConnectionId = (
  fromPort: string,
  toPort: string,
  portKey?: string | undefined,
) => {
  return typeof portKey === 'undefined' ? fromPort + toPort : portKey;
};
